import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { formatTime } from '../lib/utils';

export default function BulkEditScopeModal({ session, open, onClose, onSelect }) {
  const [scope, setScope] = useState('this_session');

  if (!session) return null;

  const dayName = new Date(session.scheduled_date + 'T00:00:00').toLocaleDateString('en', { weekday: 'long' });
  const timeStr = formatTime(session.scheduled_time);
  const instructorName = session.instructor_name || 'Instructor';

  const options = [
    { value: 'this_session', label: 'This session' },
    { value: 'all_upcoming', label: 'This and all upcoming sessions' },
    { value: 'same_day', label: `This and all upcoming sessions on ${dayName}` },
    { value: 'same_day_time', label: `This and all upcoming sessions on ${dayName}, ${timeStr}` },
    { value: 'same_time', label: `This and all upcoming sessions at ${timeStr} (any day)` },
    // Only offer the instructor-scoped option when this session actually has an
    // instructor — otherwise the scope has no meaningful filter.
    ...(session.instructor_id
      ? [{ value: 'same_instructor', label: `This and all upcoming sessions with ${instructorName}` }]
      : []),
  ];

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md" data-testid="bulk-edit-scope-modal">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl">Edit session</DialogTitle>
        </DialogHeader>
        <div className="space-y-2">
          {options.map(opt => (
            <label key={opt.value} className="flex items-center gap-3 p-3 rounded-xl hover:bg-muted/40 cursor-pointer transition-colors duration-200">
              <input
                type="radio"
                name="edit-scope"
                checked={scope === opt.value}
                onChange={() => setScope(opt.value)}
                className="w-4 h-4 text-primary"
              />
              <span className="text-sm">{opt.label}</span>
            </label>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={() => onSelect(scope)} data-testid="bulk-edit-scope-confirm">Edit</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
